// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// new Date().Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// new Date().Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
function format(fmt) {
  // author: meizzß
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}
// eslint-disable-next-line
Date.prototype.format = format
// eslint-disable-next-line
Date.prototype.getNewDate = function(count) {
  this.setDate(this.getDate() + count)
  var year = this.getFullYear()
  var month = this.getMonth() + 1
  var day = this.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + month + '-' + day
}

export function getDateRangeLength(startTime, endTime, diffType) {
  // 将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
  // eslint-disable-next-line no-useless-escape
  startTime = startTime.replace(/\-/g, '/')
  // eslint-disable-next-line no-useless-escape
  endTime = endTime.replace(/\-/g, '/')
  // 将计算间隔类性字符转换为小写
  diffType = diffType.toLowerCase()
  var sTime = new Date(startTime) // 开始时间
  var eTime = new Date(endTime) // 结束时间
  // 作为除数的数字
  var timeType = 1
  switch (diffType) {
    case 'second':
      timeType = 1000
      break
    case 'minute':
      timeType = 1000 * 60
      break
    case 'hour':
      timeType = 1000 * 3600
      break
    case 'day':
      timeType = 1000 * 3600 * 24
      break
    default:
      break
  }
  return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType))
}

export function getDateRangeArray(startDate, endDate, diffType) {
  var length = getDateRangeLength(startDate, endDate, diffType)
  var dateArray = []
  // console.log(length)
  for (var i = 0; i <= length; i++) {
    dateArray.push(new Date(endDate).getNewDate(-i))
  }
  return dateArray.sort()
};

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

// export function getMonthBetween(start, end) {
//   let result = []
//   let s = start.split('-')
//   let e = end.split('-')
//   let min = new Date()
//   let max = new Date()
//   min.setFullYear(s[0], s[1])
//   max.setFullYear(e[0], e[1])
//
//   let curr = min
//   // eslint-disable-next-line no-unmodified-loop-condition
//   while (curr <= max) {
//     var month = curr.getMonth()
//     // var monStr = month === 0 ? 12 : month
//     var showMonth = month + 1
//     result.push(curr.getFullYear() + '-' + (showMonth < 10 ? ('0' + showMonth) : showMonth))
//     curr.setMonth(month + 1)
//   }
//   return result
// }

export function getMonthBetween(start, end) {
  let result = []
  let s = start.split('-')
  let e = end.split('-')
  let startYear = parseInt(s[0])
  let endYear = parseInt(e[0])
  let startMonth = parseInt(s[1])
  let endMonth = parseInt(e[1])

  while (startYear < endYear || (startYear === endYear && startMonth <= endMonth)) {
    result.push(startYear + '-' + (startMonth < 10 ? ('0' + startMonth) : startMonth))
    if (startMonth % 12 === 0) {
      startYear++
      startMonth = 1
    } else {
      startMonth++
    }
  }
  return result
}
